import { combineReducers } from 'redux';
import appReducer from './app/reducer';
import bikeReducer from './bike/reducer';
import bikesReducer from './bikes/reducer';
import configuratorReducer from './configurator/reducer';
import taggingReducer from './tagging/reducer';
import garageReducer from './garage/reducer';

export default combineReducers({
  app: appReducer,
  bike: bikeReducer,
  bikes: bikesReducer,
  configurator: configuratorReducer,
  tagging: taggingReducer,
  garage: garageReducer,
});
